/**
 * Groups a flat list into one entry per key, preserving first-seen key order.
 *
 * @param {object[]} items - Items to group.
 * @param {(item: object) => unknown} getKey - Returns the grouping key for an item.
 * @param {(item: object) => unknown} [mapItem] - Maps each item before it is accumulated.
 * @returns {Map<unknown, unknown[]>} Key to accumulated mapped items.
 */
export const groupItemsByKey = (items, getKey, mapItem = (item) => item) => {
  const groups = new Map();

  (items ?? []).forEach((item) => {
    const key = getKey(item);

    if (!groups.has(key)) {
      groups.set(key, []);
    }

    groups.get(key).push(mapItem(item));
  });

  return groups;
};

export const safeJSONParse = (value, fallback) => {
  if (value == null) return fallback;
  try {
    return JSON.parse(value);
  } catch {
    return fallback;
  }
};
